import React from 'react'
import { Link } from 'react-router-dom'
import { InputGroup, Button } from '../../UI'

const VerifyOTPForm = ({ handleInput, formData, loading }) => {
  return (
    <>
      <InputGroup
        label="OTP Code"
        name="otp"
        type="text"
        required={true}
        placeholder="Enter 5-6 digit code"
        value={formData.otp || ''}
        onChange={handleInput}
        error={false}
        maxLength={6}
      />
      <Button
        full
        type="submit"
        className="auth--btn"
        loading={loading}
        spinnerWithTxt={true}
      >
        Verify OTP
      </Button>
      <footer>
        <p>
          Didn't receive code? <Link to="/auth/forgotten-password">Resend OTP</Link>
        </p>
        <p>
          Remember your password? <Link to="/auth/sign-in">Log in</Link>
        </p>
      </footer>
    </>
  )
}

export default VerifyOTPForm
